/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ vehicleRef: NonNullable<unknown> }} Vehicle_Action_Archive_Break_RefInputs */

const fr_vehicle_action_archive_break_ref = /** @type {(inputs: Vehicle_Action_Archive_Break_RefInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Casser l'association ${i?.vehicleRef} du véhicule`)
};

const en_vehicle_action_archive_break_ref = /** @type {(inputs: Vehicle_Action_Archive_Break_RefInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Break the association between ${i?.vehicleRef} and this vehicle`)
};

/**
* | output |
* | --- |
* | "Break the association between {vehicleRef} and this vehicle" |
*
* @param {Vehicle_Action_Archive_Break_RefInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_archive_break_ref = /** @type {((inputs: Vehicle_Action_Archive_Break_RefInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Archive_Break_RefInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_archive_break_ref(inputs)
	return en_vehicle_action_archive_break_ref(inputs)
});